module.exports = __webpack_public_path__ + "static/media/BZ.a313e321.svg";